export function BackCircleIcon() {
  return (
    <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.19385 14.47C8.19432 14.4705 8.19479 14.4709 8.19526 14.4714C8.19515 14.4713 8.19538 14.4715 8.19526 14.4714L13.5286 19.8047C13.7889 20.0651 14.2111 20.0651 14.4714 19.8047C14.7318 19.5444 14.7318 19.1223 14.4714 18.8619L10.2761 14.6667H19.3333C19.7015 14.6667 20 14.3682 20 14C20 13.6318 19.7015 13.3333 19.3333 13.3333H10.2761L14.4714 9.13807C14.7318 8.87772 14.7318 8.45561 14.4714 8.19526C14.2111 7.93491 13.7889 7.93491 13.5286 8.19526L8.19526 13.5286L8.19385 13.53C8.07404 13.6505 8 13.8166 8 14C8 14.0904 8.01799 14.1766 8.05059 14.2552C8.05206 14.2588 8.05357 14.2623 8.05511 14.2659C8.08727 14.3399 8.13352 14.4093 8.19385 14.47Z"
        fill="#06B6D4"
      />
      <rect x="0.5" y="0.5" width="27" height="27" rx="13.5" stroke="#06B6D4" />
    </svg>
  );
}
